import {
  NormalBrowseFileInputFiled,
  NormalTextEditorInputFiled,
  NormalTextInputField,
} from "@/components";
import React, { useMemo } from "react";

const AboutUsFirstTabCMSFormFields = ({
  activeTab,
  isFetching,
  formData,
  selectedTab,
  allFilesResponse,
  searchValue,
  selectedFileType,
  handleTextInputChange,
  handleTextEditorInputChange,
  handleImageChange,
  adminRole,
  permissionsList,
}) => {
  const isHideInOtherLanguages = useMemo(() => {
    return activeTab === "en" ? true : false;
  }, [activeTab]);

  return (
    <>
      {/* About Fujairah Section Form Fields */}
      {selectedTab === "section-1" && (
        <>
          {/* Page Short Description */}
          <NormalTextInputField
            isFetching={isFetching}
            isTextArea={true}
            labelText="Page Short Description"
            fieldId={`about-fujairah-page-short-description`}
            fieldName={`about-fujairah-page-short-description`}
            placeholderText="Page Short Description"
            inputValue={
              formData?.[`about-fujairah-page-short-description`] || ""
            }
            onChangeTextInputField={handleTextInputChange}
            translateField={true}
          />

          {/* Title */}
          <NormalTextInputField
            isFetching={isFetching}
            labelText="Title"
            fieldId="about-fujairah-page-title"
            fieldName="about-fujairah-page-title"
            placeholderText="Title"
            inputValue={formData?.["about-fujairah-page-title"] || ""}
            onChangeTextInputField={handleTextInputChange}
            translateField={true}
            extraContainerClasses="mt-5"
          />

          {/* Sub Title */}
          <NormalTextInputField
            isFetching={isFetching}
            isTextArea={true}
            labelText="Sub Title"
            fieldId="about-fujairah-page-sub-title"
            fieldName="about-fujairah-page-sub-title"
            placeholderText="Sub Title"
            inputValue={formData?.["about-fujairah-page-sub-title"] || ""}
            onChangeTextInputField={handleTextInputChange}
            translateField={true}
            extraContainerClasses="mt-5"
          />

          {/* Info Image */}
          {isHideInOtherLanguages && (
            <NormalBrowseFileInputFiled
              isFetching={isFetching}
              labelText="Info Image"
              fieldId="about-fujairah-info-image"
              allFilesResponse={allFilesResponse}
              searchValue={searchValue}
              selectedFileType={selectedFileType}
              onChangeImageFunction={(id) =>
                id
                  ? handleImageChange("about-fujairah-info-image", id)
                  : handleImageChange("about-fujairah-info-image", "")
              }
              selectedFileId={formData?.["about-fujairah-info-image"] || ""}
              adminRole={adminRole}
              permissionsList={permissionsList}
              extraContainerClasses="mt-5"
            />
          )}

          {/* Page Description */}
          <NormalTextEditorInputFiled
            isFetching={isFetching}
            labelText="Page Description"
            fieldId="about-fujairah-page-description"
            fieldName="about-fujairah-page-description"
            placeholderText="Page Description"
            inputValue={formData?.["about-fujairah-page-description"] || ""}
            onChangeTextEditorFiled={handleTextEditorInputChange}
            translateField={true}
            extraContainerClasses="mt-5"
          />

          {/* Card Info Heading */}
          <NormalTextInputField
            isFetching={isFetching}
            labelText="Card Info Heading"
            fieldId="about-fujairah-page-card-info-heading"
            fieldName="about-fujairah-page-card-info-heading"
            placeholderText="Card Info Heading"
            inputValue={
              formData?.["about-fujairah-page-card-info-heading"] || ""
            }
            onChangeTextInputField={handleTextInputChange}
            translateField={true}
            extraContainerClasses="mt-5"
          />

          {/* Card Info Description */}
          <NormalTextEditorInputFiled
            isFetching={isFetching}
            labelText="Card Info Description"
            fieldId="about-fujairah-page-card-info-description"
            fieldName="about-fujairah-page-card-info-description"
            placeholderText="Card Info Description"
            inputValue={
              formData?.["about-fujairah-page-card-info-description"] || ""
            }
            onChangeTextEditorFiled={handleTextEditorInputChange}
            translateField={true}
            extraContainerClasses="mt-5"
          />
        </>
      )}
    </>
  );
};

export default AboutUsFirstTabCMSFormFields;
